import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-notifications/lib/notifications.css';
import './i18n';
import { ecouterInstallation } from './components/Utils/installationPwa';

// Avant le montage : l'invite d'installation peut arriver tout de suite.
ecouterInstallation();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

reportWebVitals();